<div class="restriction-marker" [ngClass]="{ 'h-offscreen': !currentRestriction }">
  @if (currentRestriction) {
    <div class="restriction-label" data-cy="restriction-label">
      {{ currentRestriction.type }} - Bestellung auf Antrag
    </div>
  }
  @if (!currentRestriction) {
    <div>Keine Rechte Einschränkungen</div>
  }
</div>
